import queryString from 'query-string';

export const getQueryParams = () => queryString.parse(window.location.search);

export const pickQueryParams = (url, params) => queryString.pick(url, params);

export const excludeQueryParams = (url, params) => queryString.exclude(url, params);
